import checkFilled from "@/public/assets/img/check-filled.svg"
import Modal from "@/src/common/components/Modal"
import Button from "@/src/sb/components/Button"
import Image from "next/image"

type SuccessModalProps = {
  onClose?: () => void
  buttonHref?: string
}

const SuccessModal = ({ onClose, buttonHref }: SuccessModalProps) => {
  return (
    <Modal onClose={onClose} className="md:max-w-[400px]">
      <div className="bg-white p-8 text-center space-y-4 max-w-[400px]">
        <div className="inline-block">
          <Image src={checkFilled} alt="success" />
        </div>
        <h6 className="font-medium text-lg font-jakarta">
          Profile update successful
        </h6>
        <p className="font-jakarta text-gray-600">
          Thank you for updating your profile information
        </p>
        <div>
          {buttonHref ? (
            <Button type="secondary" href={buttonHref}>
              Close this page
            </Button>
          ) : (
            <Button type="secondary" onClick={onClose}>
              Close this page
            </Button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SuccessModal
